import http from "../http-common";

class CausalService {

    ingresar(data) {
        return http.post("/causal",data);
    }

    getId(id) {
        return http.get(`/causal/${id}`);
    }

    update(id, data) {
        return http.put(`/causal/${id}`,data);
    }

    getAll() {
        return http.get("/causal");
    }

    getGenGer() {
        return http.get("/causal/genger/get");
    }

    getCausalJefeRRHH() {
        return http.get("/causal/jrrhh/get");
    }

    getAllPages(page, size) {
        return http.get(`/causal/pages/p?page=${page}&size=${size}`)
    }
}

export default new CausalService();